export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5207.d5113cff.jpg";